export default __webpack_public_path__ + "static/media/refresh-ccw.b2ba4385.svg";